import { Controller } from "@hotwired/stimulus"

// Contenedor de los avisos (#flash), abajo a la izquierda. Si en la página
// hay una barra de acciones fija (formularios) y el aviso se cruzaría con
// ella, sube justo por encima; si no se cruzan (pantallas anchas, donde la
// barra queda a la derecha), se queda abajo.
const SEPARACION = 8

export default class extends Controller {
  connect() {
    this.ubicar = () => this.calcular()
    window.addEventListener("resize", this.ubicar)
    this.observador = new MutationObserver(this.ubicar) // al aparecer un aviso
    this.observador.observe(this.element, { childList: true })
    this.calcular()
  }

  disconnect() {
    window.removeEventListener("resize", this.ubicar)
    this.observador.disconnect()
  }

  calcular() {
    this.element.style.removeProperty("bottom")
    const barra = document.querySelector(".barra-acciones")
    if (!barra) return

    const avisos = this.element.getBoundingClientRect()
    const caja = barra.getBoundingClientRect()
    const seCruzan = avisos.left < caja.right && avisos.right > caja.left
    if (!seCruzan) return

    // La barra es sticky (bottom-3): su alto más ese margen, y un respiro.
    const margen = parseFloat(getComputedStyle(barra).bottom) || 0
    this.element.style.bottom = `${caja.height + margen + SEPARACION}px`
  }
}
